/**
 * Zustand store barrel export.
 *
 * Each domain store is created via `createGameStore` from @game-libs/generic-game-state
 * which provides subscribeWithSelector + persist (backed by SuperSaveSystem).
 *
 * Import individual stores from their own files, or use `resetAllStores()`
 * to reset every store at once (e.g. on clear-save).
 */

type ResetFn = () => void;

const storeResetters: ResetFn[] = [];

/**
 * Register a store's reset function. Called by each store module on creation.
 * @internal
 */
export function registerStoreReset(resetFn: ResetFn): void {
  storeResetters.push(resetFn);
}

/**
 * Reset all registered Zustand stores to their initial state.
 * Call this on clear-save before wiping persisted storage.
 */
export function resetAllStores(): void {
  for (const reset of storeResetters) {
    reset();
  }
}
